export default "__VITE_ASSET__108aff8c__"